<template>
  <img
    alt="Vue logo"
    height="150"
    src="./assets/logo.jpeg"
  />
  <div
    style="
      padding-top: 5px;
      padding-bottom: 25px;
      max-width: 600px;
      margin-left: auto;
      margin-right: auto;
    "
  >
    Spike Purity Test is a series of 100 questions regarding various experiences individuals may or may not have encountered in their Roundnet careers within the community. 
    <br />
    <strong>Notice: If you feel targeted or offended by any of the questions, feel free to complain to Dean Wasil.</strong>
  </div>
  <div
    style="
      padding: 4px;
      max-width: 500px;
      margin-left: auto;
      margin-right: auto;
    "
    v-for="(question, index) in questions"
    :key="question"
  >
    {{ index + 1 }}.
    <input
      :value="index"
      :id="`question-${index}`"
      v-model="checks"
      type="checkbox"
    />
    <label :for="`question-${index}`"> {{ question }} </label>
    <br />
  </div>
  <br />
  <div>Your score: {{ 100 - checks.length }}</div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      questions: [
        "Played spikeball?",
        "Have you ever met a Roundnet player that you just knew was the one? You stay up for hours each night thinking about them, until you finally ask them to play in a coed tournament with you and they say yes, and you think things are finally gonna pick up, but then they tell you they just want to be partners and it spirals you into a time of your life so low you think you will never recover, until they text you a month later saying they want something more, then 2 years go past and you’re stuck in a toxic relationship with someone you don’t even recognize, and you start to have talks about spending time apart, until you break up. Then 5 months go by and all you can think about we’re all those times you spent playing spike and they hit you up just to tell you that they have found a better partner and you vow to never touch a Spikeball again?",
        "Has called spikeball, “roundnet”?",
        "Has purchased Spikeball merchandise?",
        "Has a personalized team jersey?",
        "Owns a limited edition set?",
        "Owns all the limited edition sets?",
        "Played on a SLAMMO pro set?",
        "Able to wear a full Spikeball outfit from head to toe?",
        "Broken a rim?",
        "Broken 10 rims?",
        "Broken a rim on a serve?",
        "Broken a tripod?",
        "Intentionally broken a set?",
        "Been a tournament director?",
        "Got yelled at by the parks and recreation department for crop circles?",
        "Has had a kid jump on your trampoline?",
        "Big Booty Mix?",
        "Played pickup for 8+ hours in one day?",
        "Double faulted on a gentleman’s serve?",
        "Has hit a lefty fwango reverse cut drop?",
        "BANG!!!!",
        "Has been in a Spikeball group chat?",
        "Has been in the Spikeball freestyle Snapchat group?",
        "Watched spikeball on Youtube for 3+ hours straight?",
        "Made a highlight video?",
        "Googled Spikeball team names?",
        "Has had an Inappropriate team name?",
        "Has had a Spikeball related Instagram bio?",
        "Been featured on the official Spikeball Instagram?",
        "Stalked someone’s spike Instagram?",
        "Yelled a cuss word on livestream? ",
        "Gossiped on livestream?",
        "Been in an argument on the SRA Facebook group?",
        "Traveled out of state for a tournament?",
        "Driven 12+ hours for a tournament?",
        "Has Played Spikeball in multiple countries?",
        "Is planning on going to Worlds?",
        "Has stayed at a Spikehouse?",
        "Got less than 3 hours of sleep before a tournament?",
        "Pulled an all nighter the night before a tournament?",
        "Played Disc Golf, Pickleball, or Putt Putt before a tournament?",
        "Won your very first Spikeball tournament?",
        "Played in a Tour Stop?",
        "Been to Nationals?",
        "Played in a 3v3 tournament?",
        "Missed a pool play game?",
        "Lost every pool play game?",
        "Got first rounded after being predicted to win?",
        "Lost to Chico or C/S in a Nationals bracket?",
        "Been no touched by girl?",
        "Been WU’d?",
        "Been no touched by Ryder or Gabe?",
        "Choked a pro bid?",
        "Observed more games than you won at a tournament?",
        "Been aced on ESPN?",
        "Cried after losing a tournament?",
        "Wanted to quit after a tournament?",
        "Podiumed at a Tour Stop?",
        "Qualified for premier?",
        "Been backpacked or have backpaked someone?",
        "Has ghosted someone you didn’t want to play a tournament with?",
        "Couldn’t find a coed partner?",
        "Never payed your partner back for a tournament registration?",
        "Payed over $5000 in registration fees?",
        "Collided with your teammate going for a defensive touch?",
        "Gone shirtless at a tournament?",
        "Gotten seriously injured while playing?",
        "Nice.",
        "Been intoxicated during a tournament?",
        "Played a tournament hungover?",
        "Mormon?",
        "Been gypped by URA?",
        "Stolen a ball from a tournament?",
        "Lied about touching the net?",
        "Been annoyed by Preston?",
        "Actually play by the rules?",
        "Has Played call ball?",
        "Called a score fault?",
        "Argued with a Texas player?",
        "Hates Texas?!",
        "\"Retired\"?",
        "DOOOOOO",
        "Made a controversial call as a observer?",
        "Taken a full Dean?",
        "Had a crush on OJ?",
        "Had a dream about a Roundnet player?",
        "Met your significant other through Spikeball?",
        "Played a tournament with your significant other?",
        "Been with your coed partner?",
        "Incorporated Spikeball into a proposal?",
        "Played with a needle in your pocket to deflate balls?",
        "Hit a 90 degree cut?",
        "Been ranked top 10 in your state?",
        "Has shut out or been shut out by a team in a tournament game (21-0, 15-0)?",
        "Has been a Sloppy Second?",
        "Has broken glassware?",
        "Taken part in sexual act with a Spikeball?",
        "Has a Spikeball tattoo?",
        "Beastiality?",
      ],
      checks: [],
    };
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
